import { Prop } from 'vue-property-decorator';
/**
 * Prop de Vue Opcional (required = false).
 * Ej de uso : OptionalProp(Number) / OptionalProp({default: '2'})
 *
 * @param options objeto de configuracion o tipo de Prop (String, Number, etc)
 */
export function OptionalProp(options) {
    const config = isConstructor(options) ? { type: options } : options;
    return Prop({ required: false, ...config });
}
/**
 * Prop Boolean de Vue (type = Boolean).
 * Ej de uso : BooleanProp(true) / OptionalProp(true, {...})
 *
 * @param defaultValue valor boolean por default
 * @param options otras configuraciones
 */
export function BooleanProp(defaultValue, options) {
    return Prop({ type: Boolean, default: defaultValue, ...options });
}
/**
 * Prop numerica de Vue (type = Number).
 * Ej de uso : NumberProp(3) / NumberProp(4, {...})
 *
 * @param defaultValue valor numerico por default
 * @param options otras configuraciones
 */
export function NumberProp(defaultValue, options) {
    return Prop({ type: Number, default: defaultValue, ...options });
}
/**
 * Prop string de Vue (type = String).
 * Ej de uso : StringProp('valor') / StringProp('valor', {...})
 *
 * @param defaultValue valor por default
 * @param options otras configuraciones
 */
export function StringProp(defaultValue, options) {
    return Prop({ type: String, default: defaultValue, ...options });
}
/**
 * Prop de Vue con valor default en vacio.
 * El valor vacio depende del tipo (String = '', Number: 0, Boolean: false, Object: () => ({}), Array: () => []).
 * Si no se deefine tipo, se lo considera de tipo Object.
 * Ej de uso : EmptyProp(String) / EmptyProp(Array)
 *
 * @param options configuracion de la Prop o tipo
 */
export function EmptyProp(options) {
    const config = !options ? {} : isConstructor(options) ? { type: options } : options;
    // if (!config || !config.type) throw new Error('@EmptyProp debe tener un tipo');
    return Prop({ default: getDefaultValue(config.type), ...config });
}
function getDefaultValue(type) {
    if (!type)
        return () => ({});
    const name = Array.isArray(type) ? type[0].name : type.name;
    switch (name) {
        case 'Number':
            return 0;
        case 'Array':
            return () => [];
        case 'Boolean':
            return false;
        case 'String':
            return '';
        default:
            return () => ({});
    }
}
function isConstructor(obj) {
    return typeof obj === 'function';
}
//# sourceMappingURL=component.js.map